/**
 * Should be invoked whenever participants select is open
 * @type {string}
 */
export const PARTICIPANTS_SELECT_OPEN = 'participants_select_open';

/**
 * Should be invoked whenever participants select is closed
 * @type {string}
 */
export const PARTICIPANTS_SELECT_CLOSE = 'participants_select_close';

/**
 * Should be invoked whenever question select is open
 * @type {string}
 */
export const QUESTION_MODAL_OPEN = 'question_modal_open';

/**
 * Should be invoked whenever question select is closed
 * @type {string}
 */
export const QUESTION_MODAL_CLOSE = 'question_modal_close';

/**
 * Should be invoked whenever cart wrapper mobile is open
 * @type {string}
 */
export const CART_WRAPPER_OPEN = 'cart_wrapper_open';

/**
 * Should be invoked whenever cart wrapper mobile is closed
 * @type {string}
 */
export const CART_WRAPPER_CLOSE = 'cart_wrapper_close';

/**
 * Checkout payyo errors
 */

export const PAYYO_CARD_INIT_ERROR = 'payyo_card_init_error';







/**
 * @EVENTS___CreateTourForm
 * @deprecated
 */
export const CREATE_TOUR__TICKET_ADDED = 'CREATE_TOUR__TICKET_ADDED';
export const CREATE_TOUR__TICKET_DELETED = 'CREATE_TOUR__TICKET_DELETED';
export const CREATE_TOUR__TICKET_VALID = 'CREATE_TOUR__TICKET_VALID';
export const CREATE_TOUR__TICKET_INVALID = 'CREATE_TOUR__TICKET_INVALID';
export const CREATE_TOUR__TICKET_IMPORTED = 'CREATE_TOUR__TICKET_IMPORTED';

export const CREATE_TOUR__TICKET_CHANGED = 'CREATE_TOUR__TICKET_CHANGED';


export const CREATE_TOUR__OPTION_ADDED = 'CREATE_TOUR__OPTION_ADDED';
export const CREATE_TOUR__OPTION_DELETED = 'CREATE_TOUR__OPTION_DELETED';
export const CREATE_TOUR__OPTION_VALID = 'CREATE_TOUR__OPTION_VALID';
export const CREATE_TOUR__OPTION_INVALID = 'CREATE_TOUR__OPTION_INVALID';
export const CREATE_TOUR__OPTION_IMPORTED = 'CREATE_TOUR__OPTION_IMPORTED';

export const CREATE_TOUR__OPTION_CHANGED = 'CREATE_TOUR__OPTION_CHANGED';


export const CREATE_TOUR__PUSH_OPTIONS = 'CREATE_TOUR__PUSH_OPTIONS';
export const CREATE_TOUR__PUSH_TICKETS = 'CREATE_TOUR__PUSH_TICKETS';


/**
 * @endsection
 */



export const CREATE_TOUR__VALIDATION_ERROR = 'CREATE_TOUR__VALIDATION_ERROR';


export const CREATE_TOUR__CONTENT_LANGUAGE_SWITCHED = 'CREATE_TOUR__CONTENT_LANGUAGE_SWITCHED';
export const CREATE_TOUR__CONTENT_AUTOTRANSLATE = 'CREATE_TOUR__CONTENT_AUTOTRANSLATE';

/**
 * @EVENTS___CheckAvailability
 */
export const CHECK_AVAILABILITY_TICKET_COUNT_CHANGED = 'CHECK_AVAILABILITY_TICKET_COUNT_CHANGED';
export const CHECK_AVAILABILITY_OPTION_CHANGED = 'CHECK_AVAILABILITY_OPTION_CHANGED';
export const CHECK_AVAILABILITY_OPTIONS_CLEARED = 'CHECK_AVAILABILITY_OPTIONS_CLEARED';
export const CHECK_AVAILABILITY_DATE_CHANGED = 'CHECK_AVAILABILITY_DATE_CHANGED';
export const CHECK_AVAILABILITY_RESPONSE_RECEIVED = 'CHECK_AVAILABILITY_RESPONSE_RECEIVED';
export const CHECK_AVAILABILITY_CALENDAR_MONTH_CHANGED = 'CHECK_AVAILABILITY_CALENDAR_MONTH_CHANGED';


